import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=64f42094&scoped=true"
import script from "./contact.vue?vue&type=script&lang=ts"
export * from "./contact.vue?vue&type=script&lang=ts"
import style0 from "./contact.vue?vue&type=style&index=0&id=64f42094&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f42094",
  null
  
)

export default component.exports